let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("jLlTJ")).then(() => parcelRequire('eDZUG'));